import React from "react";
import { Modal, List } from "antd";
import "./ProgramsModal.css";

const ProgramsModal = ({ visible, onClose, programs, participantName }) => {
  // Parse programs string into array
  const programsList = programs ? programs.split(", ").filter(p => p.trim()) : [];

  return (
    <Modal
      title={<span className="programs-modal-title">{participantName ? `Programs for ${participantName}` : "Enrolled Programs"}</span>}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
      className="programs-modal"
    >
      <List
        dataSource={programsList}
        renderItem={(item, index) => (
          <List.Item key={index}>
            {item}
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ProgramsModal;
